var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',_vm._b({staticClass:"fill-height",class:_vm.computedDivClass,attrs:{"fluid":""}},'v-container',_vm.$attrs,false),[_c('v-row',{attrs:{"align":"center","justify":"center"}},[_c('v-flex',{class:_vm.computedClass},[_vm._t("default")],2)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }